import TenderList from './TenderList';

export default TenderList;
